import { Injectable } from '@angular/core';
import { ToothDataNew } from '../models/order.models';

@Injectable({ providedIn: 'root' })
export class ToothSelectionService {

  showBridge(toothIdA: number, bridges: any[], teethList: number[]): boolean {
    for (const bridge of bridges) {
      let bridgeStarted = false;
      let bridgeEnded = false;
      for (const teeth of teethList) {
        if (teeth === bridge.start) bridgeStarted = true;
        if (teeth === bridge.end) bridgeEnded = true;
        if (bridgeStarted && !bridgeEnded && teeth === toothIdA) return true;
      }
    }
    return false;
  }

  showBridgeDot(toothId: number, toothData: ToothDataNew[]): boolean {
    return toothData.length > 0 && toothData.some(d => d.teeth === toothId && d.bridgeConnectionType !== '');
  }

  showEmpty(toothId: number, toothData: ToothDataNew[], bridges: any[], teethList: number[]): boolean {
    if (toothData.some(d => d.teeth === toothId && d.bridgeConnectionType !== '')) return false;
    for (const bridge of bridges) {
      let bridgeStarted = false;
      let bridgeEnded = false;
      for (const teeth of teethList) {
        if (teeth === bridge.end) bridgeEnded = true;
        if (bridgeStarted && !bridgeEnded && teeth === toothId) return true;
        if (teeth === bridge.start) bridgeStarted = true;
      }
    }
    return false;
  }

  getToothColor(tooth: string, toothData: ToothDataNew[]): string {
    const colors: Record<string, string> = {
      'Crown': '#397EAC', 'Pontic': '#3939AC', 'Inlay/Onlay': '#7E39AC',
      'Veneer': '#AC3995', 'Zirkon coping': '#b3c3c3', 'Zirkon pontic': '#b3b3b3',
      'Zirkon (WAX up -2r)': '#b3b3d3', 'Abutment': '#F1BF48'
    };
    let color = '#F9F9F9';
    toothData.filter(d => d.teeth === Number(tooth)).forEach(d => {
      if (colors[d.subType]) color = colors[d.subType];
    });
    return color;
  }

  getToothColorForVisual(tooth: string, toothData: ToothDataNew[]): string {
    const n = Number(tooth);
    if (toothData.some(d => d.teeth === n && d.subType === 'Crown')) return '#397EAC';
    if (toothData.some(d => d.teeth === n && d.subType === 'Pontic')) return '#3939AC';
    if (toothData.some(d => d.teeth === n && d.subType === 'Inlay/Onlay')) return '#7E39AC';
    if (toothData.some(d => d.teeth === n && d.subType === 'Veneer')) return '#AC3995';
    if (toothData.some(d => d.teeth === n && d.subType === 'Abutment')) return '#F1BF48';
    return '#ffffff';
  }

  getTextColorForVisual(tooth: string, toothData: ToothDataNew[]): string {
    return toothData.some(d => d.teeth === Number(tooth)) ? '#000000' : '#979797';
  }

  isToothSelected(tooth: string, toothData: ToothDataNew[]): boolean {
    const subType = toothData.filter(d => d.teeth === Number(tooth)).map(d => d.subType)[0] || '';
    const sameType = toothData.filter(d => d.subType === subType);
    if (sameType.length === 0) return false;
    return sameType[0].teeth === Number(tooth) && subType !== '';
  }

  getSubTypeByTooth(tooth: string, toothData: ToothDataNew[]): string {
    return toothData.filter(d => d.teeth === Number(tooth)).map(d => d.subType)[0] || '';
  }
}
